import React, { useContext } from 'react';
import { Box, useWindowSize } from 'vindi-ds-components';

import useToggle from '@hooks/feature_toggles';
import { AdminContext } from '../../contexts/admin_context';

import SingleLinkReports from './components/singleLinkReports';
import MultiLinkReports from './components/multiLinkReports';
import AdminReport from './components/adminReport';
import CardsRenewalReport from './components/cardsRenewalReport';
import HeaderReport from './components/header';
import styles from './styles';

function Reports() {
  const { isMerchantAdmin, isCardsRenewal } = useContext(AdminContext);
  const toggle = useToggle('new_ds_reports');
  const windowSize = useWindowSize();
  const { isMobile } = windowSize;

  if (!toggle) {
    return null;
  }

  return (
    <Box px={{
      xs: 0, sm: 2, md: 4, lg: 12,
    }}
    >
      <HeaderReport isMobile={isMobile} />

      <Box css={!isMobile && styles.root}>
        <MultiLinkReports />
        <SingleLinkReports />
      </Box>
      {isMerchantAdmin && (<AdminReport isMobile={isMobile} />)}
      {isCardsRenewal && (<CardsRenewalReport isMobile={isMobile} />)}
    </Box>

  );
}

export default Reports;
